(() => {
  if (customElements.get('redefine-form')) return;
  const stateCityMap = {
  "Andhra Pradesh": [
    "Visakhapatnam"
  ],
  "Bihar": [
    "Patna"
  ],
  "Chhattisgarh": [
    "Raipur"
  ],
  "Delhi": [
    "Delhi"
  ],
  "Gujarat": [
    "Ahmedabad",
    "Gandhidham",
    "Rajkot",
    "Vadodara"
  ],
  "Haryana": [
    "Gurugram",
    "Rohtak"
  ],
  "Karnataka": [
    "Bangalore",
    "Hubballi"
  ],
  "Madhya Pradesh": [
    "Bhopal",
    "Gwalior",
    "Indore"
  ],
  "Maharashtra": [
    "Kolhapur",
    "Mumbai",
    "Pune",
    "Thane"
  ],
  "Punjab": [
    "Ludiana",
    "Mohali",
    "Zirakpur"
  ],
  "Rajasthan": [
    "Jaipur",
    "Jodhpur",
    "Udaipur"
  ],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore"
  ],
  "Telangana": [
    "Hyderabad"
  ],
  "Uttar Pradesh": [
    "Ghaziabad",
    "Kanpur",
    "Lucknow",
    "Meerut",
    "Noida",
    "Prayagraj",
    "Varanasi"
  ],
  "Uttarakhand": [
    "Dehradun"
  ],
  "West Bengal": [
    "Kolkata",
    "Siliguri"
  ]
};
  const cityStoreMap = {
  "Ahmedabad": [
    "CG Road, Ahmedabad",
    "Sindhu Bhavan, Ahmedabad"
  ],
  "Bangalore": [
    "HSR Layout, Bangalore",
    "Jayanagar, Bangalore",
    "Kormanagala, Bangalore",
    "New BEL Road, Bangalore"
  ],
  "Bhopal": [
    "Malviya Nagar, Bhopal"
  ],
  "Chennai": [
    "Anna Nagar, Chennai",
    "Catherdal Road, Chennai"
  ],
  "Coimbatore": [
    "Gandhipuram, Coimbatore"
  ],
  "Dehradun": [
    "Rajpur Road, Dehradun"
  ],
  "Delhi": [
    "Lajpat Nagar II, Delhi",
    "Pachim Vihar, Delhi",
    "Rajouri Garden, Delhi",
    "Rohini, Delhi"
  ],
  "Gandhidham": [
    "Zaveri Bazar, Gandhidham"
  ],
  "Ghaziabad": [
    "Ambedkar Road, Ghaziabad",
    "North India Mall, Ghaziabad"
  ],
  "Gurugram": [
    "Sector 69, Gurugram"
  ],
  "Gwalior": [
    "Gwalior, Madhya Pradesh"
  ],
  "Hubballi": [
    "Inorbit Mall, Hubballi"
  ],
  "Hyderabad": [
    "Gachibowli, Hyderabad",
    "Himayat Nagar, Hyderabad",
    "Somajiguda, Hyderabad"
  ],
  "Indore": [
    "AB Road, Indore",
    "MG road, Indore"
  ],
  "Jaipur": [
    "Jewels of India, Jaipur",
    "Vaishali Nagar, Jaipur"
  ],
  "Jodhpur": [
    "Sardarpura, Jodhpur"
  ],
  "Kanpur": [
    "Saket Nagar, Kanpur"
  ],
  "Kolhapur": [
    "Venus Corner, Kolhapur"
  ],
  "Kolkata": [
    "Camac Street, Kolkata",
    "Gariahat, Kolkata"
  ],
  "Lucknow": [
    "Alambag, Lucknow",
    "Lulu Mall, Lucknow"
  ],
  "Ludiana": [
    "Model Town, Ludhiana"
  ],
  "Meerut": [
    "Begum Bridge Road, Meerut"
  ],
  "Mohali": [
    "Mohali, Punjab"
  ],
  "Mumbai": [
    "Borivali, Mumbai",
    "Ghatkopar, Mumbai",
    "Juhu, Mumbai",
    "Kalaghoda, Mumbai",
    "Vashi, Navi Mumbai"
  ],
  "Noida": [
    "Gaur City Mall, Noida",
    "Wave one, Noida"
  ],
  "Patna": [
    "Frazer Road, Patna",
    "Kankarbagh, Patna"
  ],
  "Prayagraj": [
    "Civil Lines, Prayagraj"
  ],
  "Pune": [
    "Baner, Pune",
    "Bund Garden, Pune",
    "Tribeca, Pune"
  ],
  "Raipur": [
    "Pandri, Raipur"
  ],
  "Rajkot": [
    "Kalawad Road, Rajkot",
    "Palace Road, Rajkot"
  ],
  "Rohtak": [
    "Bajrang Bhawan, Rohtak"
  ],
  "Siliguri": [
    "Sevoke Road, Siliguri"
  ],
  "Thane": [
    "Naupada, Thane"
  ],
  "Udaipur": [
    "Ashok Nagar, Udaipur"
  ],
  "Vadodara": [
    "Vadodara, Gujarat"
  ],
  "Varanasi": [
    "Sigra, Varanasi"
  ],
  "Visakhapatnam": [
    "Visakhapatnam, Andhra Pradesh"
  ],
  "Zirakpur": [
    "Zirakpur, Punjab"
  ]
};
  customElements.define('redefine-form', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      if (this.controller || !this.isConnected) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const state = form.elements.namedItem('Dropdown3');
      const city = form.elements.namedItem('Dropdown2');
      const store = form.elements.namedItem('Dropdown');
      const populate = (select, values, placeholder, selected = '') => {
        select.replaceChildren(new Option(placeholder, ''), ...values.map(value => new Option(value, value)));
        select.disabled = !values.length;
        if (values.includes(selected)) select.value = selected;
      };
      const updateStore = () => populate(store, cityStoreMap[city.value] || [], 'Select nearest Limelight store', store.value);
      const updateCity = () => {
        populate(city, stateCityMap[state.value] || [], 'Select city', city.value);
        updateStore();
      };
      state.addEventListener('change', () => { city.value = ''; store.value = ''; updateCity(); }, options);
      city.addEventListener('change', () => { store.value = ''; updateStore(); }, options);
      form.addEventListener('reset', () => { this.resetFrame = requestAnimationFrame(() => { updateCity(); first.setCustomValidity(''); email.setCustomValidity(''); }); }, options);
      const first = form.elements.namedItem('Name_First');
      const email = form.elements.namedItem('Email');
      const validate = () => {
        first.setCustomValidity(first.value.trim() ? '' : 'Please enter your first name.');
        email.setCustomValidity(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()) ? '' : 'Please enter a valid email address.');
      };
      form.addEventListener('input', validate, options);
      form.addEventListener('submit', event => {
        first.value = first.value.trim(); email.value = email.value.trim();
        validate();
        if (!form.reportValidity() || !city.value || !store.value) event.preventDefault();
      }, options);
      updateCity();
      const params = new URLSearchParams(location.search);
      for (const name of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'zc_gad']) {
        const field = form.elements.namedItem(name);
        if (field) field.value = params.get(name) || '';
      }
      const floating = this.querySelector('.rdForm__floating');
      if (floating) {
        const hiddenSections = [this, ...document.querySelectorAll('redefine-banner, footer')];
        const sync = () => { floating.hidden = hiddenSections.some(element => {
          const rect = element.getBoundingClientRect();
          return rect.top < innerHeight && rect.bottom > 0;
        }); };
        sync();
        if ('IntersectionObserver' in window) {
          this.floatingObserver = new IntersectionObserver(sync);
          hiddenSections.forEach(element => this.floatingObserver.observe(element));
        } else window.addEventListener('scroll', sync, { ...options, passive: true });
        window.addEventListener('resize', sync, options);
        floating.addEventListener('click', event => {
          if (floating.getAttribute('href') !== '#' + form.id) return;
          event.preventDefault();
          form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          first.focus({ preventScroll: true });
        }, options);
      }
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); this.observer.unobserve(entry.target); }
      }), { threshold: .05, rootMargin: '0px 0px 40px 0px' });
      this.querySelectorAll('.rdForm__reveal').forEach(element => this.observer.observe(element));
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.resetFrame);
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.floatingObserver?.disconnect();
      this.classList.remove('is-ready');
    }
  });
})();
